document.addEventListener('DOMContentLoaded', function() {
  initHeader();
  initMobileMenu();
  initScrollProgress();
  initScrollytelling();
  initProductTabs();
  initFAQ();
  initExitIntent();
  initFAB();
  initTestimonialVideos();
  initScrollReveal();
  initHeroParallax();
  initSmoothAnchors();
  initCountUp();
});

function initHeader() {
  const header = document.querySelector('.header');
  if (!header) return;
  
  function updateHeader() {
    if (window.scrollY > 100) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }
  
  window.addEventListener('scroll', updateHeader);
  updateHeader();
}

function initMobileMenu() {
  const toggle = document.querySelector('.header__menu-toggle');
  const menu = document.querySelector('.mobile-menu');
  const overlay = document.querySelector('.mobile-menu__overlay');
  const close = document.querySelector('.mobile-menu__close');
  
  if (!toggle || !menu) return;
  
  function openMenu() {
    menu.classList.add('active');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  
  function closeMenu() {
    menu.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
  
  toggle.addEventListener('click', openMenu);
  if (close) close.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && menu.classList.contains('active')) closeMenu();
  });
  
  menu.querySelectorAll('.mobile-menu__link').forEach(link => {
    link.addEventListener('click', closeMenu);
  });
}

function initScrollProgress() {
  const bar = document.querySelector('.scroll-progress');
  if (!bar) return;
  
  window.addEventListener('scroll', function() {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const progress = (scrollTop / docHeight) * 100;
    bar.style.width = progress + '%';
  });
}

function initScrollytelling() {
  const section = document.querySelector('.scrollytelling');
  if (!section) return;

  const chapters = section.querySelectorAll('.scrollytelling__chapter');
  const images = section.querySelectorAll('.scrollytelling__image');
  const dots = section.querySelectorAll('.scrollytelling__dot');

  if (chapters.length === 0) return;

  function setActive(index) {
    chapters.forEach(function(ch, i) { ch.classList.toggle('active', i === index); });
    images.forEach(function(img, i) { img.classList.toggle('active', i === index); });
    dots.forEach(function(dot, i) { dot.classList.toggle('active', i === index); });
  }

  // Dot click scrolls to chapter
  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() {
      if (chapters[i]) chapters[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

  if (isDesktop && images.length > 0) {
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var index = Array.from(chapters).indexOf(entry.target);
          setActive(index);
        }
      });
    }, { root: null, rootMargin: '-40% 0px -40% 0px', threshold: 0 });

    chapters.forEach(function(chapter) { observer.observe(chapter); });
    setActive(0);
  } else {
    chapters.forEach(function(chapter) { chapter.classList.add('active'); });
    if (dots[0]) dots[0].classList.add('active');
  }
}

function initProductTabs() {
  const container = document.querySelector('.product-tabs');
  if (!container) return;
  
  const buttons = container.querySelectorAll('.product-tabs__btn');
  const panels = container.querySelectorAll('.product-tabs__panel');
  
  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const targetId = this.getAttribute('data-tab');
      buttons.forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');
      panels.forEach(function(panel) {
        panel.classList.remove('active');
        if (panel.id === targetId) panel.classList.add('active');
      });
    });
  });
}

function initFAQ() {
  const items = document.querySelectorAll('.faq__item');

  items.forEach(function(item) {
    const question = item.querySelector('.faq__question');
    const answer = item.querySelector('.faq__answer');

    question.addEventListener('click', function() {
      var isOpen = item.classList.contains('active');
      item.classList.toggle('active');
      question.setAttribute('aria-expanded', !isOpen);
      if (answer) answer.setAttribute('aria-hidden', isOpen);
    });
  });
}

function initTestimonialVideos() {
  var cards = document.querySelectorAll('[data-video-card]');
  cards.forEach(function(card) {
    var video = card.querySelector('video');
    var playBtn = card.querySelector('[data-play-btn]');
    if (!video || !playBtn) return;

    playBtn.addEventListener('click', function() {
      if (video.paused) {
        video.play();
        card.classList.add('playing');
      } else {
        video.pause();
        card.classList.remove('playing');
      }
    });

    video.addEventListener('ended', function() {
      card.classList.remove('playing');
    });
  });
}

function initExitIntent() {
  const modal = document.querySelector('.exit-modal');
  if (!modal) return;
  
  const overlay = modal.querySelector('.exit-modal__overlay');
  const closeBtn = modal.querySelector('.exit-modal__close');
  const dismissBtn = modal.querySelector('.exit-modal__dismiss');
  
  let hasShown = false;
  
  if (sessionStorage.getItem('primemind_exit_shown')) hasShown = true;
  
  function showModal() {
    if (hasShown) return;
    hasShown = true;
    sessionStorage.setItem('primemind_exit_shown', 'true');
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  
  function hideModal() {
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }
  
  document.addEventListener('mouseout', function(e) {
    if (!e.relatedTarget && e.clientY < 10) {
      setTimeout(showModal, 500);
    }
  });
  
  if (window.innerWidth < 1024) {
    setTimeout(function() {
      if (!hasShown && window.scrollY > 500) showModal();
    }, 45000);
  }
  
  if (closeBtn) closeBtn.addEventListener('click', hideModal);
  if (overlay) overlay.addEventListener('click', hideModal);
  if (dismissBtn) dismissBtn.addEventListener('click', hideModal);
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('active')) hideModal();
  });
  
  const form = modal.querySelector('.exit-modal__form');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const email = form.querySelector('.exit-modal__input').value;
      console.log('Email captured:', email);
      const body = modal.querySelector('.exit-modal__body');
      body.innerHTML = '<div style="padding: 40px 20px; text-align: center;"><h3 style="margin-bottom: 16px; color: #2D5A4A;">Welcome to PrimeMind!</h3><p style="color: #6A6A6A;">Check your email for your exclusive offer.</p></div>';
      setTimeout(hideModal, 3000);
    });
  }
}

function initFAB() {
  const fab = document.querySelector('.fab');
  if (!fab) return;
  
  const hero = document.querySelector('.hero');
  const heroHeight = hero ? hero.offsetHeight : window.innerHeight;
  
  window.addEventListener('scroll', function() {
    if (window.scrollY > heroHeight) {
      fab.classList.add('visible');
    } else {
      fab.classList.remove('visible');
    }
  });
}

// Marquee pause on hover
const marquee = document.querySelector('.marquee__track');
if (marquee) {
  marquee.addEventListener('mouseenter', function() { marquee.style.animationPlayState = 'paused'; });
  marquee.addEventListener('mouseleave', function() { marquee.style.animationPlayState = 'running'; });
}

/* ============================================
   PREMIUM ANIMATIONS
   ============================================ */

function initScrollReveal() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var revealEls = document.querySelectorAll(
    '.section, .product-card, .testimonial-card, .science__card, ' +
    '.comparison__card, .faq__item, .product-grid__header, ' +
    '.testimonials__header, .science__header, .comparison__header, ' +
    '.faq__header, .final-cta__content, .lifestyle-gallery__header, ' +
    '.trust-bar, .product-tabs__header, .product-tabs__panel.active .product-tabs__grid'
  );

  revealEls.forEach(function(el) {
    el.classList.add('reveal');
  });

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

  revealEls.forEach(function(el) { observer.observe(el); });

  // Stagger cards within grids
  var grids = document.querySelectorAll(
    '.product-grid__container, .testimonials__grid, .science__grid, .comparison__grid'
  );
  grids.forEach(function(grid) {
    var cards = grid.children;
    for (var i = 0; i < cards.length; i++) {
      cards[i].style.transitionDelay = (i * 100) + 'ms';
    }
  });
}

function initHeroParallax() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var hero = document.querySelector('.hero');
  if (!hero) return;
  var media = hero.querySelector('.hero__media');
  var content = hero.querySelector('.hero__content');
  if (!media && !content) return;

  var ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        var scrollY = window.scrollY;
        var heroH = hero.offsetHeight;
        if (scrollY < heroH) {
          var ratio = scrollY / heroH;
          if (media) media.style.transform = 'translateY(' + (scrollY * 0.3) + 'px)';
          if (content) {
            content.style.transform = 'translateY(' + (scrollY * 0.15) + 'px)';
            content.style.opacity = 1 - (ratio * 0.6);
          }
        }
        ticking = false;
      });
      ticking = true;
    }
  });
}

function initSmoothAnchors() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var targetId = this.getAttribute('href');
      if (targetId === '#' || targetId.length < 2) return;
      var target = document.querySelector(targetId);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

function initCountUp() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var counters = document.querySelectorAll('[data-count]');
  if (counters.length === 0) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-count'));
        var suffix = el.getAttribute('data-suffix') || '';
        var prefix = el.getAttribute('data-prefix') || '';
        var duration = 1500;
        var start = 0;
        var startTime = null;

        function step(timestamp) {
          if (!startTime) startTime = timestamp;
          var progress = Math.min((timestamp - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = start + (target - start) * eased;
          el.textContent = prefix + (target % 1 === 0 ? Math.round(current) : current.toFixed(1)) + suffix;
          if (progress < 1) window.requestAnimationFrame(step);
        }

        window.requestAnimationFrame(step);
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.5 });

  counters.forEach(function(el) { observer.observe(el); });
}
